// To learn more about the mappings see https://www.notion.so/fielded/How-to-model-the-location_data-on-postgres-so-it-works-for-SL-and-PSM-27607b030dfd80b5afe0db887075f605?source=copy_link#27f07b030dfd802a8bc4fa54063ed239

const fields = [
  {
    id: 'fsid',
    docProperty: '_id'
  },
  {
    id: 'uuid',
    docProperty: 'additionalData.uuid'
  },
  {
    id: 'market',
    transform: (locationEntity) => {
      const country = locationEntity.location.country
      if (country) return country
      return '' // market is not-nullable. In case the couch document doesn't have a country (which is not required on couch nor PG), we don't want it to fail
    }
  },
  {
    id: 'name_of_pharmacy',
    docProperty: 'name'
  },
  {
    id: 'lga',
    docProperty: 'location.lga'
  },
  {
    id: 'zone',
    docProperty: 'location.zone'
  },
  {
    id: 'state',
    transform: (locationEntity) => {
      if (!locationEntity.location.state) return 'N/A' // state is not-nullable in PG but some locations don't have a state on couch so we need to handle it gracefully
      return locationEntity.location.state
    }
  },
  {
    id: 'country',
    docProperty: 'location.country'
  },
  {
    id: 'lat',
    transform: (locationEntity) => {
      const latLng = locationEntity && locationEntity.additionalData
        ? locationEntity.additionalData.latLng
        : null

      if (!latLng) return null

      const parts = latLng.split(',')
      if (parts.length < 2) return null

      const lat = parseFloat(parts[1])
      return isNaN(lat) ? null : lat
    }
  },
  {
    id: 'long',
    transform: (locationEntity) => {
      const latLng = locationEntity && locationEntity.additionalData
        ? locationEntity.additionalData.latLng
        : null

      if (!latLng) return null

      const parts = latLng.split(',')
      if (parts.length < 2) return null

      const lng = parseFloat(parts[0])
      return isNaN(lng) ? null : lng
    }
  },
  {
    id: 'active',
    transform: (locationEntity) => {
      const isRetired = locationEntity.retired
      if (isRetired && isRetired === true) return false
      return true
    }
  },
  {
    id: 'address',
    docProperty: 'additionalData.physicalAddress'
  },
  {
    id: 'orders_status',
    transform: (locationEntity) => {
      const isRetired = locationEntity.retired
      if (isRetired && isRetired === true) return 'suspended'
      return 'active'
    }
  },
  {
    id: 'supply_chain_level',
    transform: (locationEntity) => {
      const locationId = locationEntity._id
      if (locationId.includes('name:')) return 'pack-point'
      return 'sdp'
    }
  }
]

module.exports = fields
